import { render, staticRenderFns } from "./welcome2.vue?vue&type=template&id=279d6e6e&scoped=true"
import script from "./welcome2.vue?vue&type=script&lang=js"
export * from "./welcome2.vue?vue&type=script&lang=js"
import style0 from "./welcome2.vue?vue&type=style&index=0&id=279d6e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279d6e6e",
  null
  
)

export default component.exports